import { QuantitativeValue } from '#/__generated__/graphql/graphql';

export function calcMaxCargoWeightInKg(cargoVolume: QuantitativeValue) {
  const BUFFERED_WEIGHT = 100; //Kilogram
  let multiplier = 1;
  switch (cargoVolume.unitCode) {
    case 'CCT':
      multiplier = 1000;
      break;
    case 'FOT':
      multiplier = 750;
      break;
    default:
      throw new Error(`${cargoVolume.unitCode} is not currently supported`);
  }
  return (cargoVolume.value ?? 0) * multiplier + BUFFERED_WEIGHT;
}
